import MapIcon from '@mui/icons-material/Map'
import GebiedsprognoseList from './GebiedsprognoseList'
import GebiedsprognoseCreate from './GebiedsprognoseCreate'
import GebiedsprognoseShow from './GebiedsprognoseShow'

const resource = {
  list: GebiedsprognoseList,
  create: GebiedsprognoseCreate,
  show: GebiedsprognoseShow,
  icon: MapIcon,
}

export default resource
